import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/k8/cluster/cluster.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
  async GET_CLUSTER_GRAPH_TABLE_DATA(
    context: { commit: Commit },
    params: {
      keyword: String;
      condition: {
        name: String;
      };
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      serviceReq: {
        capability: String;
      };
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryGetTableData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.getTeamApplicationOverview;
        } else return [];
      })
      .catch((err) => {
        console.log('Error', err);
      });
  },
  async GET_CLUSTER_CARDS_DATA(
    context: { commit: Commit },
    params: {
      keyword: String;
      condition: {
        name: String;
      };
      pagination: {
        pageNum: Number;
        pageSize: Number;
      };
      duration: {
        start: String;
        end: String;
        step: String;
      };
      serviceReq: {
        capability: String;
      };
    },
  ) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('getClusterCardsData')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.getClusterCardsData;
        } else return [];
      })
      .catch((err) => {
        console.log('Error', err);
      });
  },
};

export default actions;
